import { render, staticRenderFns } from "./SwipeBar.vue?vue&type=template&id=70795848&scoped=true"
import script from "./SwipeBar.vue?vue&type=script&lang=js"
export * from "./SwipeBar.vue?vue&type=script&lang=js"
import style0 from "./SwipeBar.vue?vue&type=style&index=0&id=70795848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70795848",
  null
  
)

export default component.exports